<span class="fa-{{size}}x"
><i class="spinning-icon fas fa-circle-notch"></i
></span>